<template>
  <div>
    <table class="table table-hover">
      <thead>
      <tr>
        <th>Deelnemer</th>
        <th>Initieel participatiebedrag</th>
        <th>Sluitingsdatum</th>
        <th>Link</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="participation in participations">
        <td><a class="hoverable" @click="$router.push({ name: 'accounts.view', params: { id: participation.account_id} })">{{participation.account_name}}</a></td>
        <td>{{participation.amount}}</td>
        <td>{{participation.closed_at}}</td>
        <td><a :href="participation.link" target="_blank">Bekijk in SalesForce</a></td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: 'project-participations',
  props: ['participations'],
}
</script>
